<template>
  <div class="contain flex justify-start flex-col w-full h-auto bg-transparent">
    <div class="m-6 sm:m-10">
      <!-- <transition-group name="slide-fade">
        <header
          key="header"
          class="contain mb-0"
        >
          <h1 class="title-2 mb-10 whitespace-normal text-left ">
            <div>Guides</div>
          </h1>
        </header>
        
      </transition-group> -->
      <transition-group name="slide-fade">
        <header key="header" class="contain mb-0">
          <h1
            class="title-2 mb-10 whitespace-normal text-left text-6xl overflow-visible"
          >
            <div class="-mb-6">
              Guides
            </div>
            <!-- <div class="hidden sm:inline -mt-8 text-red-700">{{ routeId | capitalize }}</div> -->
          </h1>
        </header>
        <section
          key="section"
          class="text-p1 text-2xl font-normal text-left max-w-sm"
        >
          Reference materials and general information.
        </section>
      </transition-group>
    </div>
    <!-- <header class="contain container--m">
        <h1 class="title-2">
          Guides
        </h1>
        <div
          class="title-2"
          v-if="!routeId"
        >
          Select a reference material from the menu.
        </div>
      </header> -->
    <section class="contain h-auto">
      <section class="item text-base w-full flex sm:text-lg md:text-2xl">
        <section
          v-if="routeId === 'tasks'"
          class="flex justify-start text-lg text-black font-bold mb-4 text-left"
        >
          Tasks Reference Guide
        </section>
        <section
          v-if="routeId === 'recipes'"
          class="flex justify-start text-lg text-black font-bold mb-4 text-left"
        >
          Recipe Guides
        </section>
        <section
          v-if="routeId === 'handbook'"
          class="flex justify-start text-lg text-black font-bold mb-4 text-left"
        >
          Handbook
        </section>
        <section
          v-if="routeId === 'procedures'"
          class="flex justify-start text-lg text-black font-bold mb-4 text-left"
        >
          Procedures Guide
        </section>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Guides',
  computed: {
    routeName: function() {
      return this.$route.name
    },
    routeId: function() {
      return this.$route.params.id
    }
  }
}
</script>
